import { userSchema } from '@sophocles/entities/User';
import { Record } from 'immutable';
import { schema } from 'normalizr';

export const SiteMaintenanceLog = new Record({
  id: undefined,
  entered_by: undefined,
  resolved_by: undefined,
  issue: 'n/a',
  resolution: 'n/a',
  time_entered: undefined,
  date_reported: undefined,
  date_resolved: undefined,
  site: undefined,
});

export const siteMaintenanceLogSchema = new schema.Entity('siteMaintenanceLogs', {
  entered_by: userSchema,
  resolved_by: userSchema,
});
